import analytics from "./components/analytics"
import menu from "./components/menu.js"
import sideNav from "./components/sideNav.js"
import forms from "./components/forms.js"
import blogSidebar from "./components/blogSidebar.js"
import blogFilters from "./components/blogFilters.js"
import blogMobileModal from "./components/blogMobileModal.js"
import carousel from "./components/carousel.js"
import media from "./components/media.js"
import homeCarousel from "./components/homeCarousel.js"
import "share-buttons"

document.addEventListener("DOMContentLoaded", function() {
  window.dataLayer = window.dataLayer || []

  analytics()
  menu()
  sideNav()
  forms()
  blogSidebar()
  blogFilters()
  blogMobileModal()
  carousel()
  media()
  homeCarousel()
})
